jQuery(function($) {
  const $els = $('[class*="js-parallax-"]');
  if (!$els.length) return;

  const INSTANT_DURATION = 1200;
  const EASING = t => 1 - Math.pow(1 - t, 3);

  const scrollTargets  = [];
  const instantTargets = [];

  $els.each(function() {
    const el = this;
    const match = el.className.match(/js-parallax-(-?\d+)-(-?\d+)-(scroll|instant)/);
    if (!match) return;

    const $img = $(el).find('img.wp-block-cover__image-background');
    if (!$img.length) return;

    const target = {
      el,
      img: $img[0],
      start: parseFloat(match[1]),
      end:   parseFloat(match[2]),
      mode:  match[3],
    };

    if (target.mode === 'scroll') {
      scrollTargets.push(target);
    } else {
      $img.css('objectPosition', '50% ' + target.start + '%');
      instantTargets.push(target);
    }
  });

  // --- scroll mode ---
  if (scrollTargets.length) {
    function updateScroll() {
      const vh = window.innerHeight;
      scrollTargets.forEach(({ el, img, start, end }) => {
        const rect     = el.getBoundingClientRect();
        const travel   = vh + rect.height;
        const scrolled = vh - rect.top;
        const progress = Math.min(Math.max(scrolled / travel, 0), 1);
        img.style.objectPosition = '50% ' + (start + progress * (end - start)) + '%';
      });
    }
    $(window).on('scroll.parallax', updateScroll);
    updateScroll();
  }

  // --- instant mode ---
  if (instantTargets.length) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const t = instantTargets.find(t => t.el === entry.target);
          if (!t) return;
          observer.unobserve(entry.target);

          const startVal = t.start;
          const endVal   = t.end;
          const began    = performance.now();

          function tick(now) {
            const progress = Math.min((now - began) / INSTANT_DURATION, 1);
            t.img.style.objectPosition = '50% ' + (startVal + EASING(progress) * (endVal - startVal)) + '%';
            if (progress < 1) requestAnimationFrame(tick);
          }

          requestAnimationFrame(tick);
        });
      },
      { rootMargin: '0px 0px -300px 0px', threshold: 0 }
    );

    instantTargets.forEach(t => observer.observe(t.el));
  }
});
